import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import {TABS_VISITOR} from "../../Model/Model";
import HandleChange from "../../../../../Helpers/HandleChange";
import routes from "../../../../../Routes/routes";
import {CUSTOM_FIELD_MODEL, VISITOR_TYPE_MODEL} from "../Model/Model";
import {permissionObj} from "../../../../../Helpers/permission";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer
 *
 * This custom hook provides state management and utilities for creating or updating visitor types.
 */
const CommonCreateUpdateVisitorTypeApp = () => {
    // Initialize translation function
    const { t } = useTranslation();

    // Redux dispatch
    const dispatch = useDispatch();

    // React Router hooks
    const navigate = useNavigate();
    const location = useLocation();

    // Extract optional ID passed via route state (e.g., for edit mode)
    let { state } = location;
    const id = state?.id;

    // State for empty fields validation
    const [emptyFields, setEmptyFields] = useState(false);

    // Get permission info from authentication slice
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    // Get development mode flag from common slice
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // The visitor type is opened as read only
    const isDetails = location?.pathname?.includes(routes.visitorType.details);

    // Creating a visitor type requires the create permission, editing an existing one requires update
    const canEdit = !isDetails && (DEV || permission?.includes(
        id ? permissionObj?.WEB_VISITOR_TYPE_UPDATE : permissionObj?.WEB_VISITOR_TYPE_CREATE
    ));

    // Local state for visitor type data
    const [item, setItem] = useState({ ...VISITOR_TYPE_MODEL });

    // Local state for custom field data
    const [fieldData, setFieldData] = useState({ ...CUSTOM_FIELD_MODEL });

    // List of dynamic fields
    const [fields, setFields] = useState([]);

    // Handle input changes for the visitor type model
    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    /**
     * Reset form states and clear visitor type data from Redux store.
     */
    const reset = () => {
        setFields([]);
        setEmptyFields(false);
        setItem({ ...VISITOR_TYPE_MODEL });
        setFieldData({ ...CUSTOM_FIELD_MODEL });
    };

    const handleOnBack = () => {
        navigate(routes.visitor.list, {
            state: {currentTab:TABS_VISITOR.TYPES.INDEX}
        });
    }
    // Expose states and handlers to be used by the consuming component
    return {
        id,
        t,
        location,
        state,
        navigate,
        dispatch,
        permission,
        DEV,
        emptyFields,
        setEmptyFields,
        item,
        setItem,
        fields,
        setFields,
        fieldData,
        setFieldData,
        reset,
        handleChange,
        handleOnBack,
        isDetails,
        canEdit
    };
};

export default CommonCreateUpdateVisitorTypeApp;
